import { render } from "./WPatientCreationForm.vue?vue&type=template&id=a42024ec&scoped=true&ts=true"
import script from "./WPatientCreationForm.vue?vue&type=script&lang=ts"
export * from "./WPatientCreationForm.vue?vue&type=script&lang=ts"

import "./WPatientCreationForm.vue?vue&type=style&index=0&id=a42024ec&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a42024ec"]])

export default __exports__